import { Button } from '@mui/material';
import { PAD_LARGE, PAD_MEDIUM } from 'providers/designSystem';
// import { COLOURS, COLOURS_DARK, COLOURS_LIGHT, PAD_MEDIUM, PAD_SMALL } from "../providers/designSystem"

// export const primaryButtonStyle = {
//     color: COLOURS_DARK.violet,
//     backgroundColor: COLOURS_LIGHT.violet,
//     paddingX: PAD_MEDIUM,
//     paddingY: PAD_SMALL,
//     '&:hover': {
//         color: COLOURS_DARK.violet,
//         backgroundColor: COLOURS.violet
//     },
// }

// export const PrimaryButton = ({
//     children,
//     onClick
// }) => {
//     return (
//         <Button sx={primaryButtonStyle} onClick={onClick}>{children}</Button>
//     )
// }

export const PrimaryButton = ({ children, onClick, paddingX = PAD_LARGE, paddingY = PAD_MEDIUM }) => {
    return (
        <Button
            variant="contained"
            size="medium"
            color="primary"
            onClick={onClick}
            type="submit"
            sx={{
                paddingX,
                paddingY,
            }}
        >
            {children}
        </Button>
    );
};

export const SecondaryButton = ({ children, onClick }) => {
    return (
        <Button variant="contained" size="small" color="secondary" onClick={onClick}>
            {children}
        </Button>
    );
};

export const TextButton = ({ children, onClick }) => {
    return (
        <Button variant="text" onClick={onClick}>
            {children}
        </Button>
    );
};
